import { StepperIndexes } from "@repo/logic";
import { FC } from "react";
import { DefaultStepProps } from "../Stepper/CustomStepper";
import { ChangeRequestSentPage } from "./ChangeRequestSentPage";
import { ChangesOverviewPage } from "./ChangesOverviewPage";
import { EditInvestmentStrategyPage } from "./EditInvestmentStrategy";
import { InvestmentProfilePage } from "./InvestmentProfilePage";
import { InvestmentStrategyIntroPage } from "./InvestmentStrategyIntroPage";
import { PensionQuestionnairePdf } from "./PensionQuestionnairePdf";
import { PensionQuestionnaireStartPage } from "./PensionQuestionnaireStartPage";
import { PensionQuestionnaireStepProps } from "./PensionQuestionnaireStepper";
import { PensionQuestionnaireWhatToChange } from "./PensionQuestionnaireWhatToChange";
import { PensionQuestionnaireWhatToChangeInvestmentStrategy } from "./PensionQuestionnaireWhatToChangeInvestmentStrategy";
import { QuestionnairePage } from "./Questionnaire/QuestionnairePage";
import { SMSVerificationPage } from "./SMSVerificationPage";
import { SustainabilityPage } from "./SustainabilityPage";
import { TelephoneNumberSelectionPage } from "./TelephoneNumberSelectionPage";
import { ChangePensionQuestionnaireIntroPage } from "./ChangePensionQuestionnaireIntroPage";

export type QuestionnairePagesType<T = unknown> = Partial<Record<StepperIndexes, FC<DefaultStepProps & T>>>;

// This is the set of possible steps, actual step list is in the redux state
export const QuestionnairePages: QuestionnairePagesType<PensionQuestionnaireStepProps> = {
    [StepperIndexes.questionnairePage]: QuestionnairePage,
    [StepperIndexes.introPage]: InvestmentStrategyIntroPage,
    [StepperIndexes.changePensionQuestionnaireIntroPage]: ChangePensionQuestionnaireIntroPage,
    [StepperIndexes.startPage]: PensionQuestionnaireStartPage,
    [StepperIndexes.phoneNumberPage]: TelephoneNumberSelectionPage,
    [StepperIndexes.smsVerificationPage]: SMSVerificationPage,
    [StepperIndexes.pdfPage]: PensionQuestionnairePdf,
    [StepperIndexes.investmentProfile]: InvestmentProfilePage,
    [StepperIndexes.sustainabilityPage]: SustainabilityPage,
    [StepperIndexes.changeRequestPage]: ChangeRequestSentPage,
    [StepperIndexes.editExistingInvestmentStrategyPage]: (props) => (
        <EditInvestmentStrategyPage {...props} mode="existing" />
    ),
    [StepperIndexes.editNewInvestmentStrategyPage]: (props) => <EditInvestmentStrategyPage {...props} mode="new" />,
    [StepperIndexes.changesOverviewPage]: ChangesOverviewPage,
    [StepperIndexes.whatToChangeInvestmentStrategy]: PensionQuestionnaireWhatToChangeInvestmentStrategy,
    [StepperIndexes.whatToChange]: PensionQuestionnaireWhatToChange,
    // Add other pages here as needed
};
